var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"py-3 px-0 pa-lg-5 primary lighten-5",attrs:{"fixed":""}},[_c('div',{staticClass:"flex-grow-1"}),_vm._t("actions")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }